import type { ReactNode } from 'react';
import './checkbox.css';

/**
 * The product's checkbox: a native input drawn in the theme, with its label.
 * The input stays a real checkbox, so keyboard, form and screen-reader behavior
 * are the browser's own; only its look is ours (`.check-box` in checkbox.css).
 */
export function Checkbox({
  checked,
  onChange,
  disabled = false,
  className,
  children,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <label className={className ? `check ${className}` : 'check'}>
      <input
        type="checkbox"
        className="check-box"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="check-label">{children}</span>
    </label>
  );
}
